import { render } from "./Rapportini.vue?vue&type=template&id=da0976e8&scoped=true&ts=true"
import script from "./Rapportini.vue?vue&type=script&lang=ts"
export * from "./Rapportini.vue?vue&type=script&lang=ts"

import "./Rapportini.vue?vue&type=style&index=0&id=da0976e8&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_puma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da0976e8"]])

export default __exports__